import React from 'react';
import { toast } from 'react-toastify';
import * as api from '../api/endpoints';

/**
 * Pinned reminder banner (e.g. "Today's priority is order 1540") --
 * stacked above the board, one row per alert still active for this
 * employee. Dismissing (the x) only hides it from this one person;
 * admins get an extra "End for everyone" to retract it for the whole team
 * at once (e.g. once the priority is actually resolved).
 */
const PriorityAlertBanner = ({ alerts, isAdmin, onChanged }) => {
  if (!alerts || alerts.length === 0) return null;

  const handleDismiss = async (alertId) => {
    try {
      await api.dismissAlert(alertId);
      onChanged();
    } catch (error) {
      toast.error('Could not dismiss this reminder.');
    }
  };

  const handleEnd = async (alertId) => {
    if (!window.confirm('End this reminder for everyone?')) return;
    try {
      await api.endAlert(alertId);
      onChanged();
    } catch (error) {
      toast.error('Could not end this reminder.');
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', padding: '0.5rem 1.25rem 0' }}>
      {alerts.map((alert) => (
        <div
          key={alert.id}
          className="priority-alert-row"
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.75rem',
            background: 'var(--danger-soft-bg)',
            borderRadius: 'var(--radius-md)', padding: '0.5rem 0.85rem', fontSize: '0.88rem',
          }}
        >
          <span>
            <strong>{alert.message}</strong>
            <span style={{ color: '#aab7c4', fontSize: '0.75rem', marginLeft: '0.5rem' }}>
              -- {alert.created_by?.display_name || 'admin'}
              {alert.expires_at && ` · auto-expires ${new Date(alert.expires_at).toLocaleString(undefined, { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}`}
            </span>
          </span>
          <span style={{ display: 'flex', gap: '0.4rem', flexShrink: 0 }}>
            {isAdmin && (
              <button type="button" className="btn-secondary" style={{ padding: '0.15rem 0.5rem', fontSize: '0.78rem' }} onClick={() => handleEnd(alert.id)}>
                End for everyone
              </button>
            )}
            <button
              type="button" className="btn-secondary" style={{ padding: '0.15rem 0.5rem', fontSize: '0.78rem' }}
              onClick={() => handleDismiss(alert.id)} aria-label="Dismiss"
            >
              &times;
            </button>
          </span>
        </div>
      ))}
    </div>
  );
};

export default PriorityAlertBanner;
